module.exports = require("escpos-usb");